<template>
    <div class="instagram-posts">
        <div class="row">
            <div class="col-md-4" v-for="post in posts">
                <div class="card">
                    <div class="card-body">
                        <img :src="post" class="img-fluid" alt="Instagram Post">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            posts: []
        }
    },
    mounted() {
        this.fetchPosts();
    },
    methods: {
        fetchPosts() {
           axios.get('/social/fetch-posts/')
                .then(response => {
                    this.posts = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
}
</script>

